import { useI18n } from '@/i18n'
import { WarningCircle } from '@/shared/icons/phosphor'
import { claimReloadAttempt, isStaleChunkError } from '@/shared/utils/chunkReload'
import { type Component, ErrorBoundary, type JSX } from 'solid-js'
import { Button } from '../../primitives/Button'

interface AppErrorBoundaryProps {
  children: JSX.Element
}

export const AppErrorBoundary: Component<AppErrorBoundaryProps> = (props) => {
  const { t } = useI18n()
  return (
    <ErrorBoundary
      fallback={(err, reset) => {
        if ((err as Error | undefined)?.name === 'SessionExpiredError') {
          return null
        }
        if (isStaleChunkError(err) && claimReloadAttempt()) {
          window.location.reload()
          return null
        }
        console.error('[AppErrorBoundary] caught render error:', err)
        return (
          <div class="flex flex-col items-center justify-center gap-3 rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-surface)] px-6 py-12 text-center">
            <div class="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-error-50)]">
              <WarningCircle class="h-6 w-6 text-[var(--color-error-600)]" />
            </div>
            <p class="text-base font-semibold text-[var(--color-text)]">
              {t('common.error.title')}
            </p>
            <p class="max-w-sm text-sm text-[var(--color-text-muted)]">{t('common.error.body')}</p>
            <Button size="sm" onClick={reset}>
              {t('common.error.retry')}
            </Button>
          </div>
        )
      }}
    >
      {props.children}
    </ErrorBoundary>
  )
}
